import React, { useState, useEffect } from 'react';
import { expertsData } from './membersData';
import { Helmet } from 'react-helmet-async';

function Members() {
  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const rules = [
      {
        re: /Кухилава\s+Екатерина\s+Сергеевна/g,
        to: 'Ekaterina Sergeevna Kukhilava',
      },
      {
        re: /Екатерина\s+Сергеевна\s+Кухилава/g,
        to: 'Ekaterina Sergeevna Kukhilava',
      },
      {
        re: /\bEkaterina\s+Kuhilava\b/g,
        to: 'Ekaterina Sergeevna Kukhilava',
      },
      {
        re: /\bKuhilava\s+Ekaterina\b/g,
        to: 'Ekaterina Sergeevna Kukhilava',
      },
      {
        re: /\bEkaterina\s+Kukhilava\b/g,
        to: 'Ekaterina Sergeevna Kukhilava',
      },
      {
        re: /\bCatherine\s+Kuhilava\b/g,
        to: 'Ekaterina Sergeevna Kukhilava',
      },
    ];

    function isBrowserTranslated() {
      const html = document.documentElement;

      return (
        html.classList.contains('translated-ltr') ||
        html.classList.contains('translated-rtl') ||
        document.querySelector('iframe.goog-te-banner-frame')
      );
    }

    function replaceText(root) {
      if (!isBrowserTranslated()) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;

      while ((node = walker.nextNode())) {
        let text = node.nodeValue;

        rules.forEach(({ re, to }) => {
          text = text.replace(re, to);
        });

        if (text !== node.nodeValue) {
          node.nodeValue = text;
        }
      }
    }

    const run = () => replaceText(document.body);

    run();

    const observer = new MutationObserver(run);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    const interval = setInterval(run, 600);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const currentItems = expertsData.slice(firstIndex, lastIndex);

  const totalPages = Math.ceil(expertsData.length / itemsPerPage);
  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="xContent p-box py-6">
      <Helmet>
        <title>Список членов Ассоциации</title>
        <meta
          name="description"
          content="Список членов Международной Ассоциации Маркетологов СНГ"
        />
        <link rel="canonical" href="https://marketing-association.com/members" />
      </Helmet>

      <h1 className="title">Список членов Ассоциации:</h1>

      <div className="expertsTable">
        <table>
          <thead>
            <tr>
              <th>№ Сертификата</th>
              <th>ФИО</th>
              <th>Страна</th>
              <th>Должность</th>
              <th>Год вступления</th>
            </tr>
          </thead>

          <tbody>
            {currentItems.map((expert) => (
              <tr key={expert.id}>
                <td>{expert.id}</td>
                <td>{expert.name}</td>
                <td>{expert.country}</td>
                <td>{expert.description}</td>
                <td>{expert.year}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => goToPage(page)}
            disabled={currentPage === page}
          >
            {page}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Members;